import { render, staticRenderFns } from "./BalanceManage.vue?vue&type=template&id=4042d204&scoped=true&"
import script from "./BalanceManage.vue?vue&type=script&lang=js&"
export * from "./BalanceManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042d204",
  null
  
)

export default component.exports